// Format numbers with JQuery number plugin
// https://github.com/customd/jquery-number
export default function() {

	let decimals = $('.number-display').attr('data-scale');
	if (typeof decimals === 'undefined') {decimals = 2;}
	$('.number-display').number( true, decimals );

	$('.number-display').on('blur', function() {
		let val = $(this).val();
		$(this).closest('.input-group').find('.hidden-number-display').val(val);
	})

}